import React from "react";

interface TickIconProps {
  width?: number | string;
  height?: number | string;
  fillColor?: string;
  className?: string;
  onClick?: () => void;
}

const TickIcon: React.FC<TickIconProps> = ({
  width = 24,
  height = 24,
  fillColor = "#9BB6C2",
  className = "",
  onClick,
}) => {
  return (
    <svg
      onClick={onClick}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7071 6.29289C20.0976 6.68342 20.0976 7.31658 19.7071 7.70711L9.70711 17.7071C9.31658 18.0976 8.68342 18.0976 8.29289 17.7071L4.29289 13.7071C3.90237 13.3166 3.90237 12.6834 4.29289 12.2929C4.68342 11.9024 5.31658 11.9024 5.70711 12.2929L9 15.5858L18.2929 6.29289C18.6834 5.90237 19.3166 5.90237 19.7071 6.29289Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default TickIcon;
